<template>
  <div class="player-points">
    <BListGroup>
      <BListGroupItem
        v-for="player in playerPoints"
        :key="player.name"
      >
        <FontAwesomeIcon
          v-if="round != null"
          class="mr-2"
          :class="{ 'text-primary': textFinished(player.name) }"
          icon="check"
        />
        <FontAwesomeIcon
          v-if="round != null"
          class="mr-2"
          :class="{ 'text-primary': guessFinished(player.name) }"
          icon="check"
        />
        {{ player.name }}: {{ player.points }} Punkte
      </BListGroupItem>
    </BListGroup>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

import resolvePlayerName from '@/shared/mixins/resolvePlayerName';

library.add(faCheck);

export default {
  name: 'PlayerPoints',
  props: {
    game: {
      type: Object,
      default: null,
    },
    round: {
      type: Object,
      default: null,
    },
  },
  mixins: [resolvePlayerName],
  computed: {
    playerPoints() {
      if (this.game == null) {
        return null;
      }
      let playerPoints = this.game.players.reduce((acc, player) => ({
        ...acc,
        [player]: {
          name: this.resolvePlayerName(player),
          points: 0,
        },
      }), {});
      this.game.rounds.forEach((round) => {
        // do not score points for a round that is not finished
        if (!round.finished) {
          return;
        }
        round.phrases.forEach((phrase) => {
          const playerPointsForPhrase = JSON.parse(JSON.stringify(playerPoints));
          let allCorrect = true;
          Object.keys(phrase.playerInputs).forEach((player) => {
            // current player can only score if another player guessed right
            if (player === round.player) {
              return;
            }
            const { guess } = phrase.playerInputs[player];
            playerPointsForPhrase[guess].points += 1;
            if (guess !== round.player) {
              allCorrect = false;
            } else {
              playerPointsForPhrase[player].points += 1;
            }
          });
          // nobody scores if everyone is right
          if (allCorrect) {
            return;
          }
          playerPoints = playerPointsForPhrase;
        });
      });
      return Object.values(playerPoints).sort((playerA, playerB) => playerB.points - playerA.points);
    },
  },
  methods: {
    textFinished(player) {
      if (this.round == null) {
        return false;
      }
      return this.round.phrases.every(phrase => (
        phrase.playerInputs != null
        && phrase.playerInputs[player] != null
        && phrase.playerInputs[player].text != null
      ));
    },
    guessFinished(player) {
      if (this.round == null) {
        return false;
      }
      if (
        this.round.player === player
        && this.textFinished(player)
      ) {
        return true;
      }
      return this.round.phrases.every(phrase => (
        phrase.playerInputs != null
        && phrase.playerInputs[player] != null
        && phrase.playerInputs[player].guess != null
      ));
    },
  },
};
</script>

<style scoped>

</style>
